import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
	displayErrorMessage,
	displayInfoMessage,
	displaySuccessMessage,
	displayWarningMessage,
} from 'redux/notificationBar/notificationBarSlice';

const useNotificationProvider = () => {
	const dispatch = useDispatch();

	const notifySuccess = useCallback(
		(message) =>
			dispatch(
				displaySuccessMessage(message ? String(message) : 'Success'),
			),
		[dispatch],
	);
	const notifyWarning = useCallback(
		(message) =>
			dispatch(
				displayWarningMessage(message ? String(message) : 'Warning'),
			),
		[dispatch],
	);
	const notifyError = useCallback(
		(message) =>
			dispatch(displayErrorMessage(message ? String(message) : 'Error')),
		[dispatch],
	);
	const notifyInfo = useCallback(
		(message) =>
			dispatch(displayInfoMessage(message ? String(message) : '')),
		[dispatch],
	);

	return { notifySuccess, notifyError, notifyWarning, notifyInfo };
};

export default useNotificationProvider;
